module.exports = __webpack_public_path__ + "static/img/4.3498df0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carouseImg/4.png
// module id = MOKA
// module chunks = 0